export class Relationship {
    public relationshipKey: string;
    public refBuyerKey: string;
    public refSellerKey: string;
    public refPlatformKey: string;
    public relationshipStatus: boolean;
    public refSellerPayableLedgerAccountKey: string;
    public buyerExternalSellerId: string;
    public platformExternalSellerId: string;
    public platformExternalBuyerId: string;
    public url: string;
    public refConfigurationKey: string;
    public enrollmentDate: object;
    public updatedAt: object;
    constructor(obj?: {
       relationshipKey?: string;
       refBuyerKey?: string;
       refSellerKey?: string;
       refPlatformKey?: string;
       relationshipStatus?: boolean;
       refSellerPayableLedgerAccountKey?: string;
       buyerExternalSellerId?: string;
       platformExternalSellerId?: string;
       platformExternalBuyerId?: string;
       url?: string;
       refConfigurationKey?: string;
       enrollmentDate?: object;
       updatedAt?: object;
    }) {
        if (obj != null) {
            this.relationshipKey = typeof obj.relationshipKey === 'undefined' ? this.relationshipKey : obj.relationshipKey;
            this.refBuyerKey = typeof obj.refBuyerKey === 'undefined' ? this.refBuyerKey : obj.refBuyerKey;
            this.refSellerKey = typeof obj.refSellerKey === 'undefined' ? this.refSellerKey : obj.refSellerKey;
            this.refPlatformKey = typeof obj.refPlatformKey === 'undefined' ? this.refPlatformKey : obj.refPlatformKey;
            this.relationshipStatus = typeof obj.relationshipStatus === 'undefined' ? this.relationshipStatus : obj.relationshipStatus;
            this.refSellerPayableLedgerAccountKey = typeof obj.refSellerPayableLedgerAccountKey === 'undefined' ? this.refSellerPayableLedgerAccountKey : obj.refSellerPayableLedgerAccountKey;
            this.buyerExternalSellerId = typeof obj.buyerExternalSellerId === 'undefined' ? this.buyerExternalSellerId : obj.buyerExternalSellerId;
            this.platformExternalSellerId = typeof obj.platformExternalSellerId === 'undefined' ? this.platformExternalSellerId : obj.platformExternalSellerId;
            this.platformExternalBuyerId = typeof obj.platformExternalBuyerId === 'undefined' ? this.platformExternalBuyerId : obj.platformExternalBuyerId;
            this.url = typeof obj.url === 'undefined' ? this.url : obj.url;
            this.refConfigurationKey = typeof obj.refConfigurationKey === 'undefined' ? this.refConfigurationKey : obj.refConfigurationKey;
            this.enrollmentDate = typeof obj.enrollmentDate === 'undefined' ? this.enrollmentDate : obj.enrollmentDate;
            this.updatedAt = typeof obj.updatedAt === 'undefined' ? this.updatedAt : obj.updatedAt;
        }
    }
}
